module.exports = __webpack_public_path__ + "static/media/muji backgound.c159f099.png";